import styled from 'styled-components';

const Toast = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
  .content {
    display: flex;
    gap: 5px;
  }
  .actions {
    display: flex;
    gap: 5px;
    justify-content: flex-end;
    button {
      background: none;
      border: none;
      color: #fff;
      text-decoration: underline;
      cursor: pointer;
    }
  }
`;

export default Toast;
